import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../../lib/auth-store';
import { useTenantConfig } from '../../lib/hooks';
import { Header } from '../header';
import { Footer } from '../footer';

/**
 * The course pages (catalogue, a course, an instructor) for a visitor while the
 * tenant keeps its courses to signed-in members (`lmsPublicCatalog` off). The
 * API refuses those reads with 401 then, so rather than render a page of empty
 * shelves the visitor is asked to log in. Anyone signed in, and every tenant
 * that shows its courses, sees the page itself.
 */
export function CoursesGate({ children }: { children: ReactNode }) {
  const signedIn = !!useAuthStore((s) => s.token);
  const closed = useTenantConfig().data?.lmsPublicCatalog === false;
  if (signedIn || !closed) return <>{children}</>;
  return (
    <div className="omni-store min-h-screen bg-lms-paper">
      <Header variant="learning" />
      <main className="mx-auto max-w-md px-4 py-20 text-center">
        <h1 className="font-lms-heading text-[27px] font-bold tracking-[-0.02em] text-lms-ink">
          Log in to see our courses
        </h1>
        <p className="mt-3 text-sm text-lms-muted">Our courses are open to members.</p>
        <Link
          to="/login"
          className="mt-8 inline-block rounded-full border border-lms-hairline bg-white px-6 py-2.5 font-semibold text-lms-ink transition-colors hover:border-lms"
        >
          Log in
        </Link>
      </main>
      <Footer variant="dark" />
    </div>
  );
}
